document.addEventListener("DOMContentLoaded", function () {
  const scrollLogo = document.querySelector("#header-scroll-logo");

  window.addEventListener("scroll", () => {
    if (window.scrollY > 46) {
      scrollLogo.classList.add("header-scroll-logo-visible");
    } else {
      scrollLogo.classList.remove("header-scroll-logo-visible");
    }
  });
});
